export default __webpack_public_path__ + "static/media/LogoWhite.5509a047.svg";